<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-11 14:35:07
 * @LastEditTime: 2024-03-15 16:48:52
 * @Description:
 * @FilePath: \website\src\components\TopHead.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="head-box">
    <div class="head-bg">
      <div>欢迎登录中国薯网!</div>
      <div class="tels">
        <div>中国薯网热线电话：0471-3371777</div>
      </div>
    </div>
    <NavMenu></NavMenu>
  </div>
</template>

<script>
import NavMenu from "./NavMenu.vue";
export default {
  name: "TopHead",
  components: { NavMenu },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.head-box {
  position: fixed;
  width: 100%;
  z-index: 1000;
  .head-bg {
    @include body-padding();
    height: 30px;
    background: #0a1a37;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    .tels {
      display: flex;
      :first-child {
        margin-right: 44px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TopHead.vue